import { SubscriptionPlanName } from '@sparemin/api-sdk';
import { BillingCyclePlanOptions } from './BillingCycleOptions';

export const PREVIOUS_COSTS_PRO: BillingCyclePlanOptions = {
  monthly: SubscriptionPlanName.PRO_20250516_MONTHLY,
  yearly: SubscriptionPlanName.PRO_20250516_YEARLY,
};

export const PREVIOUS_COSTS_BASIC: BillingCyclePlanOptions = {
  monthly: SubscriptionPlanName.BASIC_20250516_MONTHLY,
  yearly: SubscriptionPlanName.BASIC_20250516_YEARLY,
};
